import { ReactNode } from 'react';

import { HorizontalContainer } from '@/components';
import { cn } from '@/lib/cn';

type PageProps = {
    topSection?: ReactNode | null;
    children: ReactNode;
    topSectionClassName?: string;
};

export const Page = ({
    topSection,
    children,
    topSectionClassName,
}: PageProps) => {
    return (
        <div className="w-full">
            {topSection && (
                <HorizontalContainer
                    className={cn(
                        'w-full flex-wrap-reverse items-start justify-between border-b border-(--color-border-default) px-6',
                        topSectionClassName,
                    )}
                    spacing="none"
                >
                    {topSection}
                </HorizontalContainer>
            )}
            {children}
        </div>
    );
};
